import { useState } from "react";
import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  if (loading) return <div className="container"><p>Načítám…</p></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="admin-shell">
      <header className="admin-topbar">
        <button
          type="button"
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          {menuOpen ? "\u2715" : "\u2630"}
        </button>
        <h2>CityIsNews</h2>
        <nav className="desktop-nav">
          <NavLink to="/admin/contacts" className={({ isActive }) => (isActive ? "active" : "")}>
            Kontakty
          </NavLink>
          <NavLink to="/admin/lists" className={({ isActive }) => (isActive ? "active" : "")}>
            Seznamy
          </NavLink>
          <NavLink to="/admin/messages" className={({ isActive }) => (isActive ? "active" : "")}>
            Zprávy
          </NavLink>
          <NavLink to="/admin/messages/new" className={({ isActive }) => (isActive ? "active" : "")}>
            + Nová
          </NavLink>
        </nav>
        <div className="topbar-right">
          <span className="muted topbar-email">{user.email}</span>
          <button type="button" className="secondary" style={{ padding: "6px 12px", fontSize: "0.85rem" }} onClick={() => void logout()}>
            Odhlásit
          </button>
        </div>
      </header>

      {menuOpen && (
        <div className="mobile-menu-backdrop" onClick={closeMenu}>
          <nav className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <NavLink to="/admin/contacts" onClick={closeMenu}>Kontakty</NavLink>
            <NavLink to="/admin/lists" onClick={closeMenu}>Distribuční seznamy</NavLink>
            <NavLink to="/admin/messages" onClick={closeMenu}>Zprávy</NavLink>
            <NavLink to="/admin/messages/new" onClick={closeMenu}>+ Nová zpráva</NavLink>
            <div style={{ borderTop: "1px solid var(--color-border)", marginTop: 8, paddingTop: 8 }}>
              <span className="muted">{user.email}</span>
              <button type="button" className="secondary" style={{ marginTop: 8, width: "100%" }} onClick={() => { closeMenu(); void logout(); }}>
                Odhlásit
              </button>
            </div>
          </nav>
        </div>
      )}

      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
